import { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

/**
 * Branding for the tenant whose sign-in URL is being visited (/t/:slug).
 *
 * Resolves to null on the plain /login route, on an unknown slug, or if the
 * lookup fails — callers fall back to the default product identity. Sign-in
 * itself is unaffected: the tenant is always derived from the account, so a
 * wrong or missing slug changes only what the page looks like.
 */
const useTenantBranding = () => {
  const match = useMatch('/t/:slug');
  const slug = match?.params?.slug;
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!slug) {
      setBranding(null);
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetch(`/api/public/branding/${encodeURIComponent(slug)}`);
        if (!response.ok) throw new Error('unknown workspace');
        const data = await response.json();
        if (!cancelled) setBranding(data);
      } catch {
        if (!cancelled) setBranding(null);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [slug]);

  return branding;
};

export default useTenantBranding;
